import gql from 'graphql-tag';
import {PriceDetailsWrapperFragment} from '../PriceDetailsWrapper/PriceDetailsWrapperFragment';
export const ConfirmationToTIDQuery = gql`
    query confirmationToTIDQuery ($reservationId: String!, $unitLink: String!) {
        bookingConfirmation(
            reservationId: $reservationId,
            unitLink: $unitLink
        ) {
            edapAnalyticsPayload{
                fullorderrentalrate
                bidTarget
                egTrueValueAmountLocal
                currency
                eventstartdate
                eventenddate
                lengthofstay
                numadults
                numchildren
                withpets
                booking_window: bookingwindow
                book_date: bookDate
                displaycurrency
                displayquotetotal
                latitude
                listing_id:listingid
                longitude
                propertytype
                partnerfeesamount
                geoname
                lbsuuid
                admin1
                locality
                country
            }
            bookingSummary {
                reservationStatus
            }
            listing {
                contact {
                    name
                }
                detailPageUrl
                geography {
                    description
                }
                images {
                    uri
                }
                integratedPropertyManager
                platformPropertyManager
                ownerManaged
                propertyId
                isSubscription
                payPerBooking
                instantBookable
                onlineBookable
                acceptsHomeAwayPayments
                isCrossSell
                isBasicListing
            }
        }
        ecomPriceDetails (
            reservationId: $reservationId,
        ) {
            ${PriceDetailsWrapperFragment}
        }
    }
`;
